import React from "react";

const FutureAbsenceFilterButton = ({onClick, btnText, icon, color}) =>
{

    return (
        <button type='button' id={btnText} className={'btn ' + color + ' btn-icon glyphicons ' + icon +' button-style-row'}
                onClick={onClick}>{btnText}</button>
    )
}

export default FutureAbsenceFilterButton;